import React, { useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';
import InventorySelector from '../../../recoil/cashout/InventorySelector';
import ConvertCatalogSelector from '../../../recoil/cashout/ConvertCatalogSelector';
import DiamondBalance from '../common/DiamondBalance';
import ConvertCatalogHeader from './ConvertCatalogHeader';
import { filterByInventory, isBundle } from '../../helpers/ProductUtils';
import ConvertCatalogPackages from './ConvertCatalogPackages';
import ConvertConfirmationModal from './modals/ConvertConfirmationModal';

export default function Convert() {
  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        paymentProvider,
        categories: {
          conversion,
        },
      } = {},
    } = {},
  } = config || {};

  const currency = conversion.toUpperCase();
  const packages = useRecoilValue(ConvertCatalogSelector(currency));
  const inventory = useRecoilValue(InventorySelector);

  const [selectedPackage, setSelectedPackage] = useState(null);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const filteredPackages = useMemo(
    () => {
      const products = packages.filter((pkg) => !isBundle(pkg));
      return filterByInventory(products, inventory);
    },
    [packages, inventory],
  );

  const handleConvert = (pkg) => {
    setSelectedPackage(pkg);
    setShowConfirmationModal(true);
  };

  return (
    <div>
      <DiamondBalance />

      <ConvertCatalogHeader />

      <ConvertCatalogPackages
        packages={filteredPackages}
        onClick={handleConvert}
      />

      {showConfirmationModal && (
        <ConvertConfirmationModal
          paymentProvider={paymentProvider}
          selectedPackage={selectedPackage}
          onClose={() => setShowConfirmationModal(false)}
        />
      )}
    </div>
  );
}
